import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pub/no-content.png'


const _withScopeId = n => (_pushScopeId("data-v-029e5a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-wrap" }
const _hoisted_2 = { class: "no-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-content-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "no-content-text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'NoData',
  props: {
        tipText: {
            type: Array,
            default: () => [
                '暂无内容'
            ]
        }
    },
  setup(__props) {

const props = __props;

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tipText, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `tips-${index}`
          }, _toDisplayString(item), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})